export default function StripeConnectIcon(props) {
  return (
    <svg
      width={104}
      height={47}
      viewBox="0 0 104 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4361_86773)">
        <rect
          x={43.1909}
          y={14.6908}
          width={17.6184}
          height={17.6184}
          rx={8.80921}
          fill="#fff"
        />
        <path
          d="M47.935 23.5H52m4.066 0H52m0 0v-4.066m0 4.066v4.066"
          stroke="#464646"
          strokeWidth={1.01645}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x={42.5133}
        y={14.0132}
        width={18.9737}
        height={18.9737}
        rx={9.48684}
        stroke="#C7C7C7"
        strokeOpacity={0.32}
        strokeWidth={1.35526}
      />
      <rect
        x={0.5}
        y={0.460571}
        width={46.0789}
        height={46.0789}
        rx={23.0395}
        fill="#10110F"
      />
      <path
        d="M28.96 12.658h-.102l-5.319 5.344-5.318-5.344h-.103l-5.42 5.42v16.264h5.523V20.16l5.318 5.344 5.32-5.344v14.182h5.523V18.079l-5.422-5.421z"
        fill="#fff"
      />
      <rect
        x={57.4209}
        y={0.460571}
        width={46.0789}
        height={46.0789}
        rx={23.0395}
        fill="#625BF6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.658 23.669c0-1.735-.84-3.104-2.447-3.104-1.612 0-2.588 1.369-2.588 3.09 0 2.04 1.152 3.07 2.805 3.07.806 0 1.416-.183 1.877-.44v-1.356c-.46.23-.99.373-1.66.373-.657 0-1.24-.231-1.315-1.03h3.314c0-.089.013-.44.013-.604zm-3.345-.644c0-.766.468-1.084.895-1.084.413 0 .854.318.854 1.084h-1.749zm-4.303-2.46c-.664 0-1.09.312-1.328.529l-.088-.42H82.1v7.901l1.694-.359.007-1.918c.244.177.603.427 1.2.427 1.213 0 2.317-.973 2.317-3.124-.007-1.965-1.125-3.036-2.31-3.036h.002zm-.406 4.67c-.4 0-.637-.143-.8-.319l-.007-2.514c.177-.197.42-.332.807-.332.616 0 1.043.691 1.043 1.579 0 .908-.42 1.585-1.043 1.585zm-4.835-5.07l1.701-.365v-1.375l-1.7.359v1.382zm0 .516h1.701v5.929h-1.7v-5.93zm-1.823.5l-.108-.5h-1.464v5.93h1.694v-4.02c.4-.521 1.077-.426 1.288-.352v-1.558c-.217-.081-1.01-.23-1.41.5zm-3.388-1.974l-1.653.353-.007 5.428c0 1.002.752 1.741 1.755 1.741.556 0 .962-.102 1.186-.224v-1.376c-.217.089-1.287.4-1.287-.603v-2.402h1.287v-1.443h-1.288l.007-1.474zm-4.58 3.192c0-.265.217-.366.576-.366.586.012 1.16.16 1.68.433v-1.589a4.46 4.46 0 00-1.68-.311c-1.376 0-2.29.718-2.29 1.918 0 1.87 2.574 1.571 2.574 2.378 0 .312-.27.414-.65.414-.563 0-1.281-.231-1.85-.543v1.613a4.69 4.69 0 001.85.383c1.41 0 2.379-.698 2.379-1.911-.007-2.02-2.59-1.66-2.59-2.42z"
        fill="#fff"
      />
      <g clipPath="url(#clip1_4361_86773)">
        <rect
          x={43.1909}
          y={14.6908}
          width={17.6184}
          height={17.6184}
          rx={8.80921}
          fill="#fff"
        />
        <path
          d="M47.935 23.5H52m4.066 0H52m0 0v-4.066m0 4.066v4.066"
          stroke="#464646"
          strokeWidth={1.01645}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x={42.5133}
        y={14.0132}
        width={18.9737}
        height={18.9737}
        rx={9.48684}
        stroke="#fff"
        strokeOpacity={0.32}
        strokeWidth={1.35526}
      />
      <defs>
        <clipPath id="clip0_4361_86773">
          <rect
            x={43.1909}
            y={14.6908}
            width={17.6184}
            height={17.6184}
            rx={8.80921}
            fill="#fff"
          />
        </clipPath>
        <clipPath id="clip1_4361_86773">
          <rect
            x={43.1909}
            y={14.6908}
            width={17.6184}
            height={17.6184}
            rx={8.80921}
            fill="#fff"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
